import type { Citation } from '@/api/runs';

/**
 * Activating a citation asks for the source panel (prompt 14 adds it). Until
 * then the request is a window event any component can listen to.
 */

export interface OpenSourceDetail {
  messageId: string | number | null;
  runId: string | null;
  n: number;
  citation: Citation | null;
  /**
   * The control that asked (chip or source button): focus returns there.
   * Safari does not focus a clicked button, so document.activeElement
   * cannot be relied on.
   */
  opener?: HTMLElement | null;
}

export const OPEN_SOURCE_EVENT = 'qa:open-source';

export const requestOpenSource = (detail: OpenSourceDetail) => {
  window.dispatchEvent(
    new CustomEvent<OpenSourceDetail>(OPEN_SOURCE_EVENT, { detail }),
  );
};

export const onOpenSource = (listener: (detail: OpenSourceDetail) => void) => {
  const handler = (event: Event) =>
    listener((event as CustomEvent<OpenSourceDetail>).detail);
  window.addEventListener(OPEN_SOURCE_EVENT, handler);
  return () => window.removeEventListener(OPEN_SOURCE_EVENT, handler);
};
